// LoadingPage.js
import React, { useState, useEffect } from 'react';

const loadingStages = [
    "Getting Applications Details...",
    "Fetching Server Status...",
    "Scanning Vulnerabilities...",
    "Cleaning & Transforming...",
    "Processing and Analyzing...",
    "Generating Reports...",
    "Loading dashboard...",
    "Almost there..."
];

const LoadingPage = () => {
    const [currentStage, setCurrentStage] = useState(0);

    useEffect(() => {
        if (currentStage < loadingStages.length - 1) {
            const timer = setTimeout(() => {
                setCurrentStage(currentStage + 1);
            }, 500); // Change the delay as needed (milliseconds)

            return () => clearTimeout(timer);
        }
    }, [currentStage]);

    const [percentage, setPercentage] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setPercentage((prevPercentage) => {
                if (prevPercentage < 100) {
                    return prevPercentage + 1;
                } else {
                    clearInterval(interval);
                    return 100;
                }
            });
        }, 40); 

        return () => clearInterval(interval);
    }, []);

    return (

<>
        <div className="loading-page">
            <h2>{loadingStages[currentStage]}</h2>
            <br></br><br></br>

            <h2>{percentage}%</h2>
            <br></br><br></br>
            <div className="loader"></div>
        </div>

        </>
    );
};

export default LoadingPage;